import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import moment from 'moment';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import 'moment/locale/fr'; // Importez la locale française
import { IdbService } from '../idb/idb.service';
import { Location } from '@angular/common';
import { environment } from '../../../environments/environment';

moment.locale('fr');


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  local_storage_prefixe = "minoteriedusenegal.angular";
  network: any = {
    token: undefined,
    status: true,
    message: "Aucun probléme détecté",
  }

  token: any = {
    token_key: null,
    token_decoded: null,
    user_connected: null,
    is_expired: null,
    date_expiration: null
  }


  id_privilege: any
  static id_agent: number;
  menu: any[] = []
  les_utilisateurs: any[] = []
  les_commandes: any[] = []
  mode: any = {
    status: true// true = online et false = offline
  }

  /*
  1 Admin
  5 Manager
  7 Chauffeur
  8 Chef de production
  9 Agent Production
  10 Commercial
  11 Laborantin
  12 Responsable commercial
  13 Agent Livraison
  14 Chef Livraison
  */
  suivi_ble_par_jour: any[] = []
  // full_menu: any[] = [
  //   {
  //     menu_header: "Statistique",
  //     items: [
  //       {
  //         text: "Tableau de bord",
  //         path: "/home/dashboard",
  //         icone: "bx bxs-dashboard",
  //         privileges: [1, 5, 8, 11, 12, 14],
  //         items: []
  //       },
  //       {
  //         text: "Prévision",
  //         path: "/home/prevision_calendar",
  //         icone: "bx bxs-calendar ",
  //         privileges: [1, 5, 8, 11, 12, 14],
  //         items: []
  //       },
  //     ]
  //   },
  //   {
  //     menu_header: "Commercial",
  //     items: [
  //       {
  //         text: "Commande",
  //         path: "/home/commande",
  //         icone: "bx bxs-cart",
  //         privileges: [1, 5, 8, 10, 12, 13, 14],
  //         items: []
  //       },
  //       // {
  //       //   text: "Produit",
  //       //   path: "/home/produit_fini_commercial",
  //       //   icone: "bx bxs-bar-chart-alt-2",
  //       //   privileges: [1, 5, 10, 12, 14],
  //       //   items: []
  //       // },
  //       // {
  //       //   text: "Client",
  //       //   path: "/home/client",
  //       //   icone: "bx bxs-user",
  //       //   privileges: [1, 5, 10, 12, 14],
  //       //   items: []
  //       // },
  //     ]
  //   },
  //   {
  //     menu_header: "Farine 🌾",
  //     items: [
  //       {
  //         text: "Approvisionnement",
  //         path: "/home/approvisionnement",
  //         icone: "bx bx-cart-alt",
  //         privileges: [1, 5, 8, 11, 12, 14],
  //         items: [
  //           {
  //             text: "Matière première",
  //             path: "/home/matiere_premiere",
  //             icone: "bxs-map-alt",
  //             privileges: [1, 5, 8, 11, 12, 14],
  //           },
  //           {
  //             text: "Fournisseur",
  //             path: "/home/fournisseur",
  //             icone: "bx bxs-user",
  //             privileges: [1, 5, 8, 11, 12, 14],
  //           },
  //           { text: "Entrepôts", path: "/home/entrepot", icone: "", privileges: [1, 5, 8, 11, 12, 14] },
  //           {
  //             text: "Inventaire",
  //             path: "/home/inventaire",
  //             icone: "bx bxs-calendar-check",
  //             privileges: [1, 5, 8, 11, 12, 14],
  //             items: []
  //           },

  //         ]
  //       },
  //       {
  //         text: "Production",
  //         path: "/home/compteur",
  //         icone: "bx bxs-no-entry",
  //         privileges: [1, 5, 8, 9, 11],
  //         items: [
  //           {
  //             text: "Produits finis",
  //             path: "/home/produit_fini",
  //             icone: "bx bxs-no-entry",
  //             privileges: [1, 5, 8, 11],
  //             items: []
  //           },
  //           {
  //             text: "Formule",
  //             path: "/home/formule",
  //             icone: "bx bxs-bar-chart-alt-2",
  //             privileges: [1, 5, 8, 11],
  //             items: []
  //           },
  //           {
  //             text: "Melange",
  //             path: "/home/melange",
  //             icone: "bx bxs-bar-chart-alt-2",
  //             privileges: [1, 5, 8, 11],
  //             items: []
  //           }

  //         ]
  //       },
  //       {
  //         text: "Contrôle & Stock",
  //         path: "/home/controle",
  //         icone: "bx bxs-calendar-check",
  //         privileges: [1, 5, 8, 11, 14],
  //         items: []
  //       },
  //       // {
  //       //   text: "Stock",
  //       //   path: "/home/stock_produit_fini",
  //       //   icone: "bx bxs-package",
  //       //   privileges: [1, 5, 8, 11, 14], items: []
  //       // },
  //       {
  //         text: "Réparation",
  //         path: "/home/panne_compteur",
  //         icone: "bx bxs-cog",
  //         privileges: [1, 5, 8, 11, 14],
  //         items: []
  //       },
  //     ]
  //   },
  //   {
  //     menu_header: "Aliment bétail 🐄",
  //     items: [
  //       {
  //         text: "Production",
  //         path: "/home/compteur_aliment_betail",
  //         icone: "bx bxs-no-entry",
  //         privileges: [1, 5, 8, 11],
  //         items: []
  //       },
  //       {
  //         text: "Contrôle",
  //         path: "/home/controle_aliment_betail",
  //         icone: "bx bxs-calendar-check",
  //         privileges: [1, 5, 8, 11, 14],
  //         items: []
  //       },
  //       {
  //         text: "Stock",
  //         path: "/home/suivie_stock_aliment_betail",
  //         icone: "bx bxs-package",
  //         privileges: [1, 5, 8, 11, 14],
  //         items: []
  //       },
  //       {
  //         text: "Rapport",
  //         path: "/home/rapport_matiere_premiere_aliment_betail",
  //         icone: "bx bxs-package",
  //         privileges: [1, 5, 8, 11, 14],
  //         items: []
  //       }
  //     ]
  //   },
  //   {
  //     menu_header: "Suivi client",
  //     items: [
  //       {
  //         text: "Livraison",
  //         path: "/home/livraison",
  //         icone: "bx bxs-cart",
  //         privileges: [1, 5, 8, 10, 11, 12, 14],
  //         items: []
  //       },
  //     ]
  //   },
  //   {
  //     menu_header: "Ressources Hummaines",
  //     items: [
  //       // {
  //       //   text: "Employe",
  //       //   path: "/home/liason",
  //       //   icone: "bx bxs-id-card",
  //       //   privileges: [1, 5, 8, 10, 11, 12, 14],
  //       //   items: []
  //       // },
  //       {
  //         text: "Pointage",
  //         path: "/home/pointage",
  //         icone: "bx bxs-hand-up",
  //         privileges: [1, 5],
  //         items: []
  //       },

  //     ]
  //   },
  //   {
  //     menu_header: "Administration",
  //     items: [
  //       {
  //         text: "SMS",
  //         path: "/home/sms",
  //         icone: "bx bx-envelope",
  //         privileges: [1],
  //         items: []
  //       },
  //       {
  //         text: "Utilisateurs",
  //         path: "/home/employe",
  //         icone: "bx bxs-user",
  //         privileges: [1],
  //         items: []
  //       },
  //       {
  //         text: "Log",
  //         path: "/home/log",
  //         icone: "bx bxs-user",
  //         privileges: [1],
  //         items: []
  //       },
  //       {
  //         text: "Synchronisation client",
  //         path: "/home/synchronisation",
  //         icone: "bx bxs-user",
  //         privileges: [1],
  //         items: []
  //       },
  //     ]
  //   },
  // ];


  full_menu: any[] = [
    {
      title: "Dashboard",
      path: "/home/dashboard",
      icone: "bx bx-tachometer",
      privileges: [1, 5, 8, 11, 12, 14],
      items: []
    },
    {
      title: "Achats",
      path: "/home/approvisionnement",
      icone: "bx bx-cart",
      privileges: [1, 5, 8, 11, 12, 14],
      items: []
    },
    {
      title: "Productions",
      path: "/home/production",
      icone: "bx bx-bar-chart-alt-2",
      privileges: [1, 5, 8, 11, 12, 14, 9],
      items: []
    },
    {
      title: "Controle",
      path: "/home/stock",
      icone: "bx bx-check-circle",
      privileges: [1, 5, 8, 11, 12, 14],
      items: []
    },
    {
      title: "Stocks",
      path: "/home/matiere_premiere",
      icone: "bx bx-store",
      privileges: [1, 5, 8, 11, 12, 14],
      items: []
    },
    {
      title: "Commandes",
      path: "/home/commande",
      icone: "bx bx-package",
      privileges: [1, 5, 8, 11, 12, 14],
      items: []
    },
    {
      title: "Pointages",
      path: "/home/pointage",
      icone: "bx bx-time-five",
      privileges: [1, 5, 8, 11, 12, 14],
      items: []
    },
    {
      title: "Paramètres",
      path: "/home/parametre",
      icone: "bx bx-cog",
      privileges: [1, 5, 8, 11, 12, 14],
      items: []
    },
    {
      title: "Sms",
      path: "/home/sms",
      icone: "bx bx-envelope",
      privileges: [1],
      items: []
    },



  ];

  les_droits: any = {
    // gestion des fonctionnalités
    "type_employe.edit": [1],
    "livraison.add": [1, 5, 10, 12],
    "livraison.edit": [1, 12],
    // modifier une commande
    "commande.edit": [1, 5, 12],
    "commande.prix_ui.edit": [1, 5, 12],
    "client.edit": [1, 5, 12],
    // gestion des routes
    "/home": [1, 5, 7, 8, 9],
    "/home/employe": [1],
    "/home/approvisionnement": [1, 5, 10, 12],
    "/home/fournisseur": [1, 5, 12],
    "/home/matiere_premiere": [1, 5, 11, 11, 10, 12],
    "/home/entrepot": [1, 5],
    "/home/piece_detache": [1, 5],
    "/home/compteur": [1, 5, 8, 9, 11],
    "/home/additif": [1, 5, 8],
    "/home/formule": [1, 5, 11],
    "/home/commande": [1, 5, 8, 10, 12, 13, 14],
    "/home/client": [1, 5, 10, 12],
    "/home/client.edit": [1, 5],
    "/home/produit_fini": [1, 5, 10, 7, 11, 12],
    "/home/livraison": [1, 5, 11, 10, 12],
    "/home/stock": [1, 5, 8, 9, 10, 12],
    "/home/profil": [1, 5, 8, 9, 7, 10, 11, 12],
    // "/home/acceuil-client": [null],
  }

  dashboard_data: any = {
    production_livraison: [],
    les_matiere_premieres: [],
    suivi_ble_par_jour: [],
  }

  hide_on_print = false
  version: any = {
    id: "2.3.0"
  }

  preference: any = {
    "commande.filter": undefined,
  }


  constructor(private http: HttpClient, private route: Router, private idb: IdbService, public location: Location) { }

  async get_from_local_storage(key: string): Promise<any> {
    try {
      let res: any = await this.idb.get_from_indexedDB(key)
      return res
    } catch (error) {
      console.error("erreur de recuperation", error)
      return null
    }
  }
  async save_on_local_storage(key: string, value: any): Promise<void> {
    await this.idb.save_on_indexedDB(key, value);
  }
  async delete_from_local_storage(key: string) {
    await this.idb.delete_from_indexedDB(key);
  }
  get_token() {
    //le token n'est pas encore chargé
    if (this.network.token == undefined) {
      this.network.token = this.get_from_local_storage("token")
      if (this.network.token != undefined && this.network.token != null) {// token existant
        this.update_data_from_token()// mise a jour du token
      }
    } else {// token dèja chargé
      this.update_data_from_token()// mise a jour du token
    }
    return this.network.token
  }

  //les requetes http
  async taf_get(path: string, on_success: Function, on_error: Function) {
    let api_url = environment.taf_base_url + path;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + await this.get_token(),
      })
    };

    this.http.get(api_url, httpOptions).subscribe(
      (reponse: any) => {// on success
        on_success(reponse)
      },
      (error: any) => {// on error
        this.on_taf_get_error(error, on_error)
      }
    )
  }

  on_taf_get_error(error: any, on_error: Function) {
    this.network.status = false;
    this.network.message = error
    alert("Merci de vérifier votre connexion")
    on_error(error)
  }

  async taf_post(path: string, data_to_send: any, on_success: Function, on_error: Function, ignore_offline: boolean = false) {
    if (!ignore_offline) {
      let segments = path.split("/")
      let dernier = segments[segments.length - 1]
      if (dernier.includes("get")) {// reception
        let reponse_offline = await this.get_from_local_storage(path + JSON.stringify(data_to_send))
        if (reponse_offline != null) {
          on_success(reponse_offline, true)
          console.log("On charge les données locales en attendant = ", reponse_offline)
        }
      }
    }

    let api_url = environment.taf_base_url + path;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + await this.get_token(),
      })
    };
    this.http.post(api_url, data_to_send, httpOptions).subscribe(
      (reponse: any) => {// on success
        on_success(reponse)
        // if (!ignore_offline) {
        this.save_on_local_storage(path, reponse)
        // }
      },
      (error: any) => {// on error
        this.on_taf_post_error(error, on_error)
      }
    )
  }
  // async taf_post(path: string, data_to_send: any, on_success: Function, on_error: Function) {
  //   // toujours chercher les données en local avant de demander au backend
  //   let segments = path.split("/")
  //   let dernier = segments[segments.length - 1]
  //   if (dernier.includes("get")) {// reception
  //     let reponse_offline = await this.get_from_local_storage(path)
  //     if (reponse_offline == null) {
  //       reponse_offline = {
  //         status: true,
  //         data: []
  //       }
  //     }
  //     console.log("on est pas en ligne et reponse_offline= ", reponse_offline)
  //     on_success(reponse_offline)
  //   }
  //   // sauvegarder les ajout d'en cas de off line
  //   if (!this.mode.status) {// on est pas en ligne
  //     if (dernier.includes("add")) {// ajout
  //       // LS recuperer
  //       let data_offline = (await this.get_from_local_storage(path)) || []
  //       data_offline.push(data_to_send)
  //       await this.save_on_local_storage(path, data_offline)

  //       console.log("on est pas en ligne et taf_post_add")
  //       on_success({ status: true })
  //     } else {
  //       alert("requete impossible en mode hors ligne")
  //       on_error({ status: false })
  //     }
  //     return
  //   }

  //   let api_url = environment.taf_base_url + path;
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       Authorization: "Bearer " + await this.get_token(),
  //     })
  //   };
  //   this.http.post(api_url, data_to_send, httpOptions).subscribe(
  //     (reponse: any) => {// on success
  //       on_success(reponse)
  //       this.save_on_local_storage(path, reponse)
  //     },
  //     (error: any) => {// on error
  //       this.on_taf_post_error(error, on_error)
  //     }
  //   )
  // }

  async taf_post_login(path: string, data_to_send: any, on_success: Function, on_error: Function) {
    let api_url = environment.taf_base_url + path;

    this.http.post(api_url, data_to_send).subscribe(
      (reponse: any) => {// on success
        on_success(reponse)
      },
      (error: any) => {// on error
        this.on_taf_post_error(error, on_error)
      }
    )
  }

  on_taf_post_error(error: any, on_error: any) {
    this.network.status = false;
    this.network.message = error
    alert("Merci de vérifier votre connexion")
    on_error(error)
  }

  async update_data_from_token() {
    this.preference = (await this.get_from_local_storage("preference")) || this.preference

    let token_key = await this.get_from_local_storage("token")
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(token_key);
    const expirationDate = helper.getTokenExpirationDate(token_key);
    const isExpired = helper.isTokenExpired(token_key);

    this.token = {
      token_key: token_key,
      token_decoded: decodedToken,
      user_connected: decodedToken?.taf_data,
      is_expired: isExpired,
      date_expiration: expirationDate
    }
    if (this.token.is_expired) {
      this.on_token_expire()
    }
  }

  decode_token(token_text: string) {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(token_text);
    const expirationDate = helper.getTokenExpirationDate(token_text);
    const isExpired = helper.isTokenExpired(token_text);

    return {
      token_key: token_text,
      token_decoded: decodedToken,
      user_connected: decodedToken.taf_data,
      is_expired: isExpired,
      date_expiration: expirationDate
    }
  }

  on_token_expire() {
    alert("Votre session s'est expiré! Veuillez vous connecter à nouveau")
    this.delete_from_local_storage("token")
    this.route.navigate(['/public/login'])
  }

  Swal_success(title: any) {
    return Swal.fire({
      title: title,
      icon: "success",
      timer: 2500,
      timerProgressBar: true,
      showConfirmButton: false
    });
  }

  Swal_error(title: any) {
    return Swal.fire({
      title: title,
      icon: "error",
      timer: 4000,
      timerProgressBar: true,
      showConfirmButton: true
    });
  }

  Swal_info(title: any) {
    return Swal.fire({
      title: title,
      icon: "info",
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false
    });
  }

  async Swal_confirm() {
    const result = await Swal.fire({
      title: "Etes-vous sûr de vouloir supprimer",
      text: "C'est irréversible",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non"
    });
    return result.isConfirmed;
  }
  async _Swal_confirm(titre: string, text: string) {
    const result = await Swal.fire({
      title: titre,
      text: text,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non"
    });
    return result.isConfirmed;
  }

  async Swal_confirm_edit_melange() {
    const result = await Swal.fire({
      title: "Etes-vous sûr de vouloir modifier",
      text: "⚠️Attention : cette action peut affecter les productions existantes. Pour un nouveau mélange, cliquez sur '+Ajouter mélange'.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non"
    });
    return result.isConfirmed;
  }

  async Swal_confirm_edit_patch() {
    const result = await Swal.fire({
      title: "Etes-vous sûr de vouloir modifier",
      text: "⚠️Attention : cette action peut affecter les productions existantes. Pour un nouveau patch, cliquez sur 'nouveau patch'.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non"
    });
    return result.isConfirmed;
  }

  deconnexion() {
    this.delete_from_local_storage("token")

    this.network = {
      token: undefined,
      status: true,
      message: "Aucun probléme détecté",
    }
    this.token = {
      token_key: null,
      token_decoded: null,
      user_connected: null,
      is_expired: null,
      date_expiration: null
    }
    this.route.navigate(['/'])
  }

  // custom_menu() {
  //   // console.log("agent", this.token.token_decoded.taf_data)
  //   let id_type_employe = +this.token.token_decoded.taf_data.id_type_employe || -1

  //   this.menu = this.full_menu.map((one: any) => {
  //     let res = Object.assign({}, one)
  //     // Appp, Pro, Comm, PF, U
  //     res.items = one.items.filter((one_item: any) => {
  //       let is_vide = one_item.privileges.length == 0
  //       let es_dans_privileges = one_item.privileges.indexOf(id_type_employe) != -1
  //       return is_vide || es_dans_privileges
  //     }).map((one_item: any) => {
  //       let res2 = Object.assign({}, one_item)
  //       res2.items = one_item.items.filter((one_sub_item: any) => {
  //         let is_vide = one_sub_item.privileges.length == 0
  //         let es_dans_privileges = one_sub_item.privileges.indexOf(id_type_employe) != -1
  //         return is_vide || es_dans_privileges
  //       })
  //       return res2
  //     })

  //     console.log(this.menu, 'menu');

  //     return res
  //   }).filter((one: any) => {
  //     return one.items.length > 0
  //   })


  //   // console.log("full_menu= ", this.full_menu, " menu= ", this.menu)
  // }

  custom_menu() {
    let id_type_employe = +this.token.token_decoded.taf_data.id_type_employe || -1;

    this.menu = this.full_menu.filter((one_item: any) => {
      let is_vide = !one_item.privileges || one_item.privileges.length == 0;
      let es_dans_privileges = one_item.privileges.indexOf(id_type_employe) != -1;

      return is_vide || es_dans_privileges;
    }).map((one_item: any) => {
      let res = Object.assign({}, one_item);
      if (one_item.items && one_item.items.length > 0) {
        res.items = one_item.items.filter((sub: any) => {
          return !sub.privileges || sub.privileges.length == 0 || sub.privileges.indexOf(id_type_employe) != -1;
        });
      }
      return res;
    });

    console.log("Menu final filtré :", this.menu);
  }

  format_date(date_string: string) {
    return {
      full: moment(date_string).locale("fr").format("dddd Do MMMM YYYY"),// 27 février 2023
      jma: moment(date_string).locale("fr").format("Do MMMM YYYY"),// jeudi ...
      jma2: moment(date_string).locale("fr").format("DD-MM-YYYY"),// 01-11-2023
      jma3: moment(date_string).locale("fr").format("YYYY-MM-DD"),// 2023-10-21
      jma3_hour: moment(date_string).locale("fr").format("YYYY-MM-DD HH:mm"),// 2023-10-21 14:50
      full_datetime: moment(date_string).locale("fr").format("dddd Do MMMM YYYY à HH:mm"),// 27 février 2023
      full_date: moment(date_string).locale("fr").format("Do MMMM YYYY"),// 27 février 2023
    }
  }

  format_current_date() {
    return {
      full: moment().locale("fr").format("dddd Do MMMM YYYY"),// 27 février 2023
      jma: moment().locale("fr").format("Do MMMM YYYY"),// jeudi ...
      jma2: moment().locale("fr").format("DD-MM-YYYY"),// 01-11-2023
      jma3: moment().locale("fr").format("YYYY-MM-DD"),// 2023-10-21
      full_datetime: moment().locale("fr").format("dddd Do MMMM YYYY à HH:mm"),// 27 février 2023
    }
  }

  can(action: string): boolean {
    let id_type_employe = this.token.token_decoded.taf_data.id_type_employe || -1
    if (this.les_droits[action] && this.les_droits[action].indexOf(+id_type_employe) != -1) {
      return true
    } else {
      return false
    }
  }

  transformer_matiere_premiere(data: any[]): any[] {
    return data.map((one: any) => {
      one.quantite_theorique = +one.dernier_inventaire + +one.quantite_recue - +one.quantite_utilise_compteur
      one.ecart = +one.quantite_reelle - +one.quantite_theorique
      // ecart
      if (one.ecart < 0) {
        one.ecart_couleur = "bg-danger"
      } else if (one.ecart == 0) {
        one.ecart_couleur = "bg-success"
      } else if (one.ecart > 0) {
        one.ecart_couleur = "bg-secondary"
      }
      return one
    })
  }

  // pour l'affichage d'un inventaire déjà enregistré (inventaire/get_inventaire_2) :
  // les valeurs sont figées, on ne fait que calculer l'écart, sans recalculer le stock théorique
  transformer_matiere_premiere_snapshot(data: any[]): any[] {
    return data.map((one: any) => {
      one.ecart = +one.quantite_reelle - +one.quantite_theorique
      if (one.ecart < 0) {
        one.ecart_couleur = "bg-danger"
      } else if (one.ecart == 0) {
        one.ecart_couleur = "bg-success"
      } else {
        one.ecart_couleur = "bg-secondary"
      }
      return one
    })
  }

  transformer_matiere_premiere_stock(data: any[]): any[] {
    return data.map((one: any) => {
      if (+one.id_type_matiere_premiere == 1) {// Blé T
        one.quantite_theorique = +one.dernier_inventaire + +one.quantite_recue - +one.quantite_utilise_compteur
      } else if (+one.id_type_matiere_premiere == 5) {// Additif Farine
        one.quantite_theorique = +one.dernier_inventaire + +one.quantite_recue - (+one.quantite_utilise_additif / 1000)
      } else if (+one.id_type_matiere_premiere == 2) {// Piece détaché
        one.quantite_theorique = +one.dernier_inventaire + +one.quantite_recue - +one.quantite_utilise_piece
      } else if (+one.id_type_matiere_premiere == 3 || +one.id_type_matiere_premiere == 63) {// Sac
        one.quantite_theorique = +one.dernier_inventaire + +one.quantite_recue - (+one.quantite_utilise_sac || +one.quantite_utilise_sac_aliment_betail)
      } else if (+one.id_type_matiere_premiere == 6 || +one.id_type_matiere_premiere == 7) {// Aliment Bétail
        one.quantite_theorique = +one.dernier_inventaire + +one.quantite_recue - +one.quantite_utilise_aliment_betail
      } else {
        one.quantite_theorique = null
      }
      // ecart
      if (+one.quantite_theorique < +one.seuil_de_stock) {
        one.ecart_couleur = "bg-danger"
      } else if (one.quantite_theorique < 2 * one.seuil_de_stock) {
        one.ecart_couleur = "bg-warning"
      } else {
        one.ecart_couleur = "bg-success"
      }
      return one
    })
  }

  transformer_commande(data: any[]) {
    return data.reduce((res: any[], actu_v: any) => {
      let actu = Object.assign({}, actu_v)
      // verifier si
      let actu_existe_index = res.findIndex((one: any) => one.id_client == actu.id_client && moment(one.date_heure).diff(actu.date_heure, "day") == 0)// -1 s'il n'existe pas
      if (actu_existe_index !== -1) {
        res[actu_existe_index].les_details.push(actu);
      } else {
        const newEntry = {
          id_commande: actu.id_commande,
          prenom_nom_client: `${actu.prenom_client || ""} ${actu.nom_client || ""}`,
          date_heure: actu.date_heure,
          date_livraison: actu.date_livraison,
          id_client: actu.id_client,
          les_details: [actu]
        };
        res.push(newEntry);
      }
      return res
    }, [])
      .map((one: any) => {
        one.les_details = one.les_details.map((one_details: any) => {
          one_details.les_quantites.map((un: any) => {
            if (un.id_etat_commande == 2) {
              un.etat_commande_couleur = "bg-success"
            } else if (un.id_etat_commande == 3) {
              un.etat_commande_couleur = "bg-danger"
            } else if (un.id_etat_commande == 4) {
              un.etat_commande_couleur = "bg-warning"
            } else if (un.id_etat_commande == 5) {
              un.etat_commande_couleur = "bg-info"
            } else {
              un.etat_commande_couleur = "bg-secondary"
            }
            return un
          })
          let last_detail = one_details.les_quantites[0]
          one_details.montant_a_payer = (+last_detail?.quantite) * (+last_detail?.prix_ui)
          one_details.reste_a_livrer = +last_detail?.quantite - +one_details.total_livre
          // etat restee_a_livrer
          if (last_detail.id_etat_commande == 3) {
            one_details.reste_a_livre_couleur = "bg-danger"
          } else if (+last_detail?.quantite > 0 && +one_details.reste_a_livrer <= 0) {
            one_details.reste_a_livre_couleur = 'bg-success'
          } else if (+last_detail?.quantite > 0 && +one_details.reste_a_livrer < +last_detail?.quantite) {
            one_details.reste_a_livre_couleur = 'bg-warning'
          } else {
            one_details.reste_a_livre_couleur = 'bg-secondary'
          }
          return one_details
        })
        one.montant_a_payer = one.les_details.reduce((prev: number, actu: any) => {
          return prev + +actu.montant_a_payer
        }, 0)
        one.quantite_com = one.les_details.reduce((prev: number, actu: any) => {
          return prev + +(actu.les_quantites[0]?.quantite)
        }, 0)
        one.reste_a_livre = one.les_details.reduce((prev: number, actu: any) => {
          return +prev + +actu.reste_a_livrer;
        }, 0)
        return one
      })

  }

  transformer_stock(data: any[]) {
    let donnee = {
      production: { ultra: 0, normal: 0, vierge: 0, son: 0, stock_ultra: 0, stock_normal: 0, stock_vierge: 0, stock_son: 0, da: 0 },
      livraison: { ultra: 0, normal: 0, vierge: 0, son: 0 },
      ameliorant: { ultra: 0, normal: 0, vierge: 0, son: 0 },
      casse: { ultra: 0, normal: 0, vierge: 0, son: 0 },
      ensache: { ultra: 0, normal: 0, vierge: 0, son: 0 },
      controle: { ultra: 0, normal: 0, vierge: 0, son: 0 }
    }

    let res1 = data.reduce((res: any[], actu_v1: any) => {
      let actu = Object.assign(actu_v1)
      // verifier si
      let actu_existe_index = res.findIndex((one: any) => one.date == actu.date && one.is_controle == actu.is_controle)// -1 s'il n'existe pas

      if (actu_existe_index != -1) {// verifier si l'id de actu est dèja dans la liste
        // on aajoute pas dans res
        // afficher uniquement FN et FU
        if (actu.id_produit_fini == 1 || actu.id_produit_fini == 2 || actu.id_produit_fini == 5 || actu.id_produit_fini == 4 || actu.id_produit_fini == 3 || actu.id_produit_fini == null) {
          if (actu.is_controle == 1) {
            if (actu.id_produit_fini == 1 || actu.id_produit_fini == 5 || actu.id_produit_fini == 3) {// FN
              res[actu_existe_index].les_details.production.stock_normal += +actu.quantite_produite
              res[actu_existe_index].les_details.controle.normal = 1
              res[actu_existe_index].les_details.casse.normal += +actu.quantite_casse;
              res[actu_existe_index].les_details.ensache.normal += +actu.quantite_ensache;
              res[actu_existe_index].les_details.ameliorant.normal += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 2) { // FU
              res[actu_existe_index].les_details.production.stock_ultra += +actu.quantite_produite
              res[actu_existe_index].les_details.controle.ultra = 1
              res[actu_existe_index].les_details.casse.ultra += +actu.quantite_casse;
              res[actu_existe_index].les_details.ensache.ultra += +actu.quantite_ensache;
              res[actu_existe_index].les_details.ameliorant.ultra += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 5 || actu.id_produit_fini == 3) { // FV
              res[actu_existe_index].les_details.production.stock_vierge += +actu.quantite_produite
              res[actu_existe_index].les_details.controle.vierge = 1
              res[actu_existe_index].les_details.casse.vierge += +actu.quantite_casse;
              res[actu_existe_index].les_details.ensache.vierge += +actu.quantite_ensache;
              res[actu_existe_index].les_details.ameliorant.vierge += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 4) { // son
              res[actu_existe_index].les_details.production.stock_son += +actu.quantite_produite
              res[actu_existe_index].les_details.controle.son = 1
              res[actu_existe_index].les_details.casse.son += +actu.quantite_casse;
              res[actu_existe_index].les_details.ensache.son += +actu.quantite_ensache;
              res[actu_existe_index].les_details.ameliorant.son += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == null) { //da
              console.log('da1', actu.quantite_produite);

              res[actu_existe_index].les_details.production.da += +actu.quantite_produite;
            }
          } else {
            if (actu.id_produit_fini == 1 || actu.id_produit_fini == 5 || actu.id_produit_fini == 3 || actu.id_produit_fini == null) {
              res[actu_existe_index].les_details.production.normal += +actu.quantite_produite;
              res[actu_existe_index].les_details.livraison.normal += +actu.quantite_livree;

              res[actu_existe_index].les_details.production.stock_normal = +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            }
            else if (actu.id_produit_fini == 2) {
              res[actu_existe_index].les_details.production.ultra += +actu.quantite_produite;
              res[actu_existe_index].les_details.livraison.ultra += +actu.quantite_livree;

              res[actu_existe_index].les_details.production.stock_ultra += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 5 || actu.id_produit_fini == 3) {
              res[actu_existe_index].les_details.production.vierge += +actu.quantite_produite;
              res[actu_existe_index].les_details.livraison.vierge += +actu.quantite_livree;

              res[actu_existe_index].les_details.production.stock_vierge += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 4) {
              res[actu_existe_index].les_details.production.son += +actu.quantite_produite;
              res[actu_existe_index].les_details.livraison.son += +actu.quantite_livree;
              res[actu_existe_index].les_details.production.stock_son += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == null) {
              console.log('da2', actu.quantite_produite);

              res[actu_existe_index].les_details.production.da += +actu.quantite_produite;
            }
          }
        }
      } else {//
        // actu.les_details = []
        // afficher uniquement FN et FU
        if (actu.id_produit_fini == 1 || actu.id_produit_fini == 2 || actu.id_produit_fini == 5 || actu.id_produit_fini == 4 || actu.id_produit_fini == 3 || actu.id_produit_fini == null) {
          donnee = {
            production: { ultra: 0, normal: 0, vierge: 0, son: 0, stock_ultra: 0, stock_normal: 0, stock_vierge: 0, stock_son: 0, da: 0 },
            livraison: { ultra: 0, normal: 0, vierge: 0, son: 0 },
            ameliorant: { ultra: 0, normal: 0, vierge: 0, son: 0 },
            casse: { ultra: 0, normal: 0, vierge: 0, son: 0 },
            ensache: { ultra: 0, normal: 0, vierge: 0, son: 0 },
            controle: { ultra: 0, normal: 0, vierge: 0, son: 0 }
          }
          if (actu.is_controle == 1) {
            if (actu.id_produit_fini == 1 || actu.id_produit_fini == 5 || actu.id_produit_fini == 3) {// FN
              donnee.production.stock_normal += +actu.quantite_produite
              donnee.controle.normal = 1
              donnee.casse.normal += +actu.quantite_casse;
              donnee.ensache.normal += +actu.quantite_ensache;
              donnee.ameliorant.normal += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 2) { // FU
              donnee.production.stock_ultra += +actu.quantite_produite
              donnee.controle.ultra = 1
              donnee.casse.ultra += +actu.quantite_casse;
              donnee.ensache.ultra += +actu.quantite_ensache;
              donnee.ameliorant.ultra += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 5 || actu.id_produit_fini == 3) { // FV
              donnee.production.stock_vierge += +actu.quantite_produite
              donnee.controle.vierge = 1
              donnee.casse.vierge += +actu.quantite_casse;
              donnee.ensache.vierge += +actu.quantite_ensache;
              donnee.ameliorant.vierge += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 4) { // son
              donnee.production.stock_son += +actu.quantite_produite
              donnee.controle.son = 1
              donnee.casse.son += +actu.quantite_casse;
              donnee.ensache.son += +actu.quantite_ensache;
              donnee.ameliorant.son += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == null) {
              console.log('da3', actu.quantite_produite);

              actu.production_da += +actu.quantite_produite;
            }
          } else {
            if (actu.id_produit_fini == 1 || actu.id_produit_fini == 5 || actu.id_produit_fini == 3) {// FN
              donnee.production.normal += +actu.stock_reel || +actu.quantite_produite;
              donnee.livraison.normal += +actu.quantite_livree || 0;

              donnee.production.stock_normal += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 2) { // FU
              donnee.production.ultra += +actu.stock_reel || +actu.quantite_produite;
              donnee.livraison.ultra += +actu.quantite_livree || 0;

              donnee.production.stock_ultra += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 5 || actu.id_produit_fini == 3) { // FV
              donnee.production.vierge += +actu.stock_reel || +actu.quantite_produite;
              donnee.livraison.vierge += +actu.quantite_livree || 0;

              donnee.production.stock_vierge += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 4) { // son
              donnee.production.son += +actu.stock_reel || +actu.quantite_produite;
              donnee.livraison.son += +actu.quantite_livree || 0;

              donnee.production.stock_son += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == null) {
              console.log('da4', actu.quantite_produite, '/', actu.date);

              actu.production_da += +actu.quantite_produite;
            }
          }
          actu.les_details = donnee;
          res.push(actu)
        }
      }

      return res
    }, []).reverse()
    console.log(res1);

    let res2 = res1.reduce((res: any, actu: any, index: number) => {
      actu.index = index
      let precedent = res[index - 1]
      actu.precedent = precedent
      actu.suivant = res1[index + 1]

      actu.controle_veille = res?.reduce((r: any, one: any) => {
        if (+one.is_controle == 1 && one.date != actu.date && moment((r || res[0]).date).isBefore(one.date)) {
          r = one
        }
        return r
      }, undefined)
      actu.mouvement_veille = res?.reduce((r: any, one: any) => {
        if (+one.is_controle == 0 && one.date != actu.date && moment((r || res[0]).date).isBefore(one.date)) {
          r = one
        }
        return r
      }, undefined)
      if (actu.is_controle == 1) {
        actu.cumul_stock_normal = (actu.les_details.controle.normal == 1) ? (actu.les_details.production.stock_normal || 0) : (precedent?.cumul_stock_normal || 0)
        actu.cumul_stock_ultra = (actu.les_details.controle.ultra == 1) ? +(actu.les_details.production.stock_ultra || 0) : (precedent?.cumul_stock_ultra || 0)
        actu.cumul_stock_vierge = (actu.les_details.controle.vierge == 1) ? +(actu.les_details.production.stock_vierge || 0) : (precedent?.cumul_stock_vierge || 0)
        actu.cumul_stock_son = (actu.les_details.controle.son == 1) ? +(actu.les_details.production.stock_son || 0) : (precedent?.cumul_stock_son || 0)
        actu.stock_theorique_ultra = +actu.les_details.production.stock_ultra

        // actu.cumul_stock_ultra = +(actu.les_details.production.stock_ultra || 0)
        // actu.cumul_stock_normal = +(actu.les_details.production.stock_normal || 0)
        // actu.cumul_stock_vierge = +(actu.les_details.production.stock_vierge || 0)
        // actu.cumul_stock_son = +(actu.les_details.production.stock_son || 0)

        actu.theorique_matin_normal = +actu.controle_veille?.les_details.production.stock_normal + +actu?.les_details.ensache.normal - +actu?.suivant?.les_details.livraison.normal
        actu.difference_normal = actu.les_details.production.stock_normal - +actu.theorique_matin_normal
        if (Math.abs(actu.difference_normal) <= 1) {
          actu.color_normal = "border border-success p-1 rounded-2"

          // actu.color_normal = "badge bg-success text-white"
        } else if (Math.abs(actu.difference_normal) < 3) {
          actu.color_normal = "border border-warning p-1 rounded-2"

          // actu.color_normal = "badge bg-warning text-white"
        } else {
          actu.color_normal = "border border-danger p-1 rounded-2"
          // actu.color_normal = "badge bg-danger text-white"
        }
        actu.difference_ensache_normal = actu?.les_details.ensache.normal - actu?.suivant?.les_details.production.normal + +actu?.les_details.casse.normal + +actu?.les_details.ameliorant.normal
        if (Math.abs(actu.difference_ensache_normal) <= 1) {
          actu.color_ensache_normal = "bg-success text-white"
        } else if (Math.abs(actu.difference_ensache_normal) < 3) {
          actu.color_ensache_normal = "bg-warning text-white"
        } else {
          actu.color_ensache_normal = "bg-danger text-white"
        }
        actu.theorique_matin_ultra = +actu.controle_veille?.les_details.production.stock_ultra + +actu?.les_details.ensache.ultra - +actu?.suivant?.les_details.livraison.ultra// - +actu?.les_details.casse.ultra - +actu?.les_details.ameliorant.ultra
        actu.difference_ultra = actu.les_details.production.stock_ultra - +actu.theorique_matin_ultra
        // actu.difference_ultra = (+precedent?.cumul_stock_ultra || 0) - +actu.les_details.production.stock_ultra
        if (Math.abs(actu.difference_ultra) <= 1) {
          actu.color_ultra = "border border-success p-1 rounded-2"
        } else if (Math.abs(actu.difference_ultra) < 3) {
          actu.color_ultra = "border border-warning p-1 rounded-2"
        } else {
          actu.color_ultra = "border border-danger p-1 rounded-2"
        }
        actu.difference_ensache_ultra = actu?.les_details.ensache.ultra - actu?.suivant?.les_details.production.ultra + +actu?.les_details.casse.ultra + +actu?.les_details.ameliorant.ultra
        if (Math.abs(actu.difference_ensache_ultra) <= 1) {
          actu.color_ensache_ultra = "bg-success text-white"
        } else if (Math.abs(actu.difference_ensache_ultra) < 3) {
          actu.color_ensache_ultra = "bg-warning text-white"
        } else {
          actu.color_ensache_ultra = "bg-danger text-white"
        }
        actu.theorique_matin_vierge = +actu.controle_veille?.les_details.production.stock_vierge + +actu?.les_details.ensache.vierge - +actu?.suivant?.les_details.livraison.vierge// - +actu?.les_details.casse.vierge - +actu?.les_details.ameliorant.vierge
        actu.difference_vierge = actu.les_details.production.stock_vierge - +actu.theorique_matin_vierge
        if (Math.abs(actu.difference_vierge) <= 1) {
          actu.color_vierge = "badge bg-success text-white"
        } else if (Math.abs(actu.difference_vierge) < 3) {
          actu.color_vierge = "badge bg-warning text-white"
        } else {
          actu.color_vierge = "badge bg-danger text-white"
        }
        actu.difference_ensache_vierge = actu?.les_details.ensache.vierge - actu?.suivant?.les_details.production.vierge + +actu?.les_details.casse.vierge + +actu?.les_details.ameliorant.vierge
        if (Math.abs(actu.difference_ensache_vierge) <= 1) {
          actu.color_ensache_vierge = "bg-success text-white"
        } else if (Math.abs(actu.difference_ensache_vierge) < 3) {
          actu.color_ensache_vierge = "bg-warning text-white"
        } else {
          actu.color_ensache_vierge = "bg-danger text-white"
        }
        actu.theorique_matin_son = +actu.controle_veille?.les_details.production.stock_son + +actu?.les_details.ensache.son - +actu?.suivant?.les_details.livraison.son// - +actu?.les_details.casse.son - +actu?.les_details.ameliorant.son
        actu.difference_son = actu.les_details.production.stock_son - +actu.theorique_matin_son
        // actu.difference_son = (+precedent?.cumul_stock_son || 0) - +actu.les_details.production.stock_son
        if (Math.abs(actu.difference_son) <= 1) {
          actu.color_son = "border border-success p-1 rounded-2"
        } else if (Math.abs(actu.difference_son) < 3) {
          actu.color_son = "border border-warning p-1 rounded-2"
        } else {
          actu.color_son = "border border-danger p-1 rounded-2"
        }
        actu.difference_ensache_son = actu?.les_details.ensache.son - actu?.suivant?.les_details.production.son + +actu?.les_details.casse.son + +actu?.les_details.ameliorant.son
        if (Math.abs(actu.difference_ensache_son) <= 1) {
          actu.color_ensache_son = "bg-success text-white"
        } else if (Math.abs(actu.difference_ensache_son) < 3) {
          actu.color_ensache_son = "bg-warning text-white"
        } else {
          actu.color_ensache_son = "bg-danger text-white"
        }
      } else {
        actu.cumul_stock_ultra = +(actu.les_details.production.stock_ultra || 0) + (precedent?.cumul_stock_ultra || 0)// cumul_stock_ultra précédent
        actu.cumul_stock_normal = +(actu.les_details.production.stock_normal || 0) + (precedent?.cumul_stock_normal || 0)// cumul_stock_ultra précédent
        actu.cumul_stock_vierge = +(actu.les_details.production.stock_vierge || 0) + (precedent?.cumul_stock_vierge || 0)// cumul_stock_vierge précédent
        actu.cumul_stock_son = +(actu.les_details.production.stock_son || 0) + (precedent?.cumul_stock_son || 0)// cumul_stock_vierge précédent
        actu.stock_theorique_ultra = +actu.controle_veille?.stock_theorique_ultra + +(actu.mouvement_veille?.les_details.production.stock_ultra || 0)
      }
      res.push(actu)
      return res
    }, [])
      .reverse()
    return res2
  }

  transformer_stock2(data: any[]) {
    let donnee = {
      production: { ultra: 0, normal: 0, vierge: 0, son: 0, stock_ultra: 0, stock_normal: 0, stock_vierge: 0, stock_son: 0, da: 0 },
      livraison: { ultra: 0, normal: 0, vierge: 0, son: 0 },
      ameliorant: { ultra: 0, normal: 0, vierge: 0, son: 0 },
      casse: { ultra: 0, normal: 0, vierge: 0, son: 0 },
      ensache: { ultra: 0, normal: 0, vierge: 0, son: 0 },
      controle: { ultra: 0, normal: 0, vierge: 0, son: 0 }
    }

    let res1 = data.reduce((res: any[], actu_v1: any) => {
      let actu = Object.assign(actu_v1)
      // verifier si
      let actu_existe_index = res.findIndex((one: any) => one.date == actu.date && one.is_controle == actu.is_controle)// -1 s'il n'existe pas

      if (actu_existe_index != -1) {// verifier si l'id de actu est dèja dans la liste
        // on aajoute pas dans res
        // afficher uniquement FN et FU
        if (actu.id_produit_fini == 1 || actu.id_produit_fini == 2 || actu.id_produit_fini == 5 || actu.id_produit_fini == 4 || actu.id_produit_fini == 3) {
          if (actu.is_controle == 1) {
            if (actu.id_produit_fini == 1 || actu.id_produit_fini == 5 || actu.id_produit_fini == 3) {// FN
              res[actu_existe_index].les_details.production.stock_normal += +actu.quantite_produite
              res[actu_existe_index].les_details.controle.normal = 1
              res[actu_existe_index].les_details.casse.normal += +actu.quantite_casse;
              res[actu_existe_index].les_details.ensache.normal += +actu.quantite_ensache;
              res[actu_existe_index].les_details.ameliorant.normal += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 2) { // FU
              res[actu_existe_index].les_details.production.stock_ultra += +actu.quantite_produite
              res[actu_existe_index].les_details.controle.ultra = 1
              res[actu_existe_index].les_details.casse.ultra += +actu.quantite_casse;
              res[actu_existe_index].les_details.ensache.ultra += +actu.quantite_ensache;
              res[actu_existe_index].les_details.ameliorant.ultra += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 5 || actu.id_produit_fini == 3) { // FV
              res[actu_existe_index].les_details.production.stock_vierge += +actu.quantite_produite
              res[actu_existe_index].les_details.controle.vierge = 1
              res[actu_existe_index].les_details.casse.vierge += +actu.quantite_casse;
              res[actu_existe_index].les_details.ensache.vierge += +actu.quantite_ensache;
              res[actu_existe_index].les_details.ameliorant.vierge += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 4) { // son
              res[actu_existe_index].les_details.production.stock_son += +actu.quantite_produite
              res[actu_existe_index].les_details.controle.son = 1
              res[actu_existe_index].les_details.casse.son += +actu.quantite_casse;
              res[actu_existe_index].les_details.ensache.son += +actu.quantite_ensache;
              res[actu_existe_index].les_details.ameliorant.son += +actu.quantite_ameliorant;
            } //else if (actu.id_produit_fini == null) {
            //   res[actu_existe_index].les_details.production.da += +actu.quantite_produite;
            // }
          } else {
            if (actu.id_produit_fini == 1 || actu.id_produit_fini == 5 || actu.id_produit_fini == 3) {
              res[actu_existe_index].les_details.production.normal += +actu.quantite_produite;
              res[actu_existe_index].les_details.livraison.normal += +actu.quantite_livree;

              res[actu_existe_index].les_details.production.stock_normal = +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            }
            else if (actu.id_produit_fini == 2) {
              res[actu_existe_index].les_details.production.ultra += +actu.quantite_produite;
              res[actu_existe_index].les_details.livraison.ultra += +actu.quantite_livree;

              res[actu_existe_index].les_details.production.stock_ultra += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 5 || actu.id_produit_fini == 3) {
              res[actu_existe_index].les_details.production.vierge += +actu.quantite_produite;
              res[actu_existe_index].les_details.livraison.vierge += +actu.quantite_livree;

              res[actu_existe_index].les_details.production.stock_vierge += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 4) {
              res[actu_existe_index].les_details.production.son += +actu.quantite_produite;
              res[actu_existe_index].les_details.livraison.son += +actu.quantite_livree;
              res[actu_existe_index].les_details.production.stock_son += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } //else if (actu.id_produit_fini == null) {
            //   res[actu_existe_index].les_details.production.da += +actu.quantite_produite;
            // }
          }
        }
      } else {//
        // actu.les_details = []
        // afficher uniquement FN et FU
        if (actu.id_produit_fini == 1 || actu.id_produit_fini == 2 || actu.id_produit_fini == 5 || actu.id_produit_fini == 4 || actu.id_produit_fini == 3) {
          donnee = {
            production: { ultra: 0, normal: 0, vierge: 0, son: 0, stock_ultra: 0, stock_normal: 0, stock_vierge: 0, stock_son: 0, da: 0 },
            livraison: { ultra: 0, normal: 0, vierge: 0, son: 0 },
            ameliorant: { ultra: 0, normal: 0, vierge: 0, son: 0 },
            casse: { ultra: 0, normal: 0, vierge: 0, son: 0 },
            ensache: { ultra: 0, normal: 0, vierge: 0, son: 0 },
            controle: { ultra: 0, normal: 0, vierge: 0, son: 0 }
          }
          if (actu.is_controle == 1) {
            if (actu.id_produit_fini == 1 || actu.id_produit_fini == 5 || actu.id_produit_fini == 3) {// FN
              donnee.production.stock_normal += +actu.quantite_produite
              donnee.controle.normal = 1
              donnee.casse.normal += +actu.quantite_casse;
              donnee.ensache.normal += +actu.quantite_ensache;
              donnee.ameliorant.normal += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 2) { // FU
              donnee.production.stock_ultra += +actu.quantite_produite
              donnee.controle.ultra = 1
              donnee.casse.ultra += +actu.quantite_casse;
              donnee.ensache.ultra += +actu.quantite_ensache;
              donnee.ameliorant.ultra += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 5 || actu.id_produit_fini == 3) { // FV
              donnee.production.stock_vierge += +actu.quantite_produite
              donnee.controle.vierge = 1
              donnee.casse.vierge += +actu.quantite_casse;
              donnee.ensache.vierge += +actu.quantite_ensache;
              donnee.ameliorant.vierge += +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 4) { // son
              donnee.production.stock_son += +actu.quantite_produite
              donnee.controle.son = 1
              donnee.casse.son += +actu.quantite_casse;
              donnee.ensache.son += +actu.quantite_ensache;
              donnee.ameliorant.son += +actu.quantite_ameliorant;
            } //else if (actu.id_produit_fini == null) {
            //   actu.production_da += +actu.quantite_produite;
            // }
          } else {
            if (actu.id_produit_fini == 1 || actu.id_produit_fini == 5 || actu.id_produit_fini == 3) {// FN
              donnee.production.normal += +actu.stock_reel || +actu.quantite_produite;
              donnee.livraison.normal += +actu.quantite_livree || 0;

              donnee.production.stock_normal += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 2) { // FU
              donnee.production.ultra += +actu.stock_reel || +actu.quantite_produite;
              donnee.livraison.ultra += +actu.quantite_livree || 0;

              donnee.production.stock_ultra += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 5 || actu.id_produit_fini == 3) { // FV
              donnee.production.vierge += +actu.stock_reel || +actu.quantite_produite;
              donnee.livraison.vierge += +actu.quantite_livree || 0;

              donnee.production.stock_vierge += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } else if (actu.id_produit_fini == 4) { // son
              donnee.production.son += +actu.stock_reel || +actu.quantite_produite;
              donnee.livraison.son += +actu.quantite_livree || 0;

              donnee.production.stock_son += +actu.quantite_produite - +actu.quantite_livree - +actu.quantite_casse - +actu.quantite_ameliorant;
            } //else if (actu.id_produit_fini == null) {
            //   actu.production_da += +actu.quantite_produite;
            // }
          }
          actu.les_details = donnee;
          res.push(actu)
        }
      }

      return res
    }, []).reverse()
    console.log(res1);

    let res2 = res1.reduce((res: any, actu: any, index: number) => {
      actu.index = index
      let precedent = res[index - 1]
      actu.precedent = precedent
      actu.suivant = res1[index + 1]

      actu.controle_veille = res?.reduce((r: any, one: any) => {
        if (+one.is_controle == 1 && one.date != actu.date && moment((r || res[0]).date).isBefore(one.date)) {
          r = one
        }
        return r
      }, undefined)
      actu.mouvement_veille = res?.reduce((r: any, one: any) => {
        if (+one.is_controle == 0 && one.date != actu.date && moment((r || res[0]).date).isBefore(one.date)) {
          r = one
        }
        return r
      }, undefined)
      if (actu.is_controle == 1) {
        actu.cumul_stock_normal = (actu.les_details.controle.normal == 1) ? (actu.les_details.production.stock_normal || 0) : (precedent?.cumul_stock_normal || 0)
        actu.cumul_stock_ultra = (actu.les_details.controle.ultra == 1) ? +(actu.les_details.production.stock_ultra || 0) : (precedent?.cumul_stock_ultra || 0)
        actu.cumul_stock_vierge = (actu.les_details.controle.vierge == 1) ? +(actu.les_details.production.stock_vierge || 0) : (precedent?.cumul_stock_vierge || 0)
        actu.cumul_stock_son = (actu.les_details.controle.son == 1) ? +(actu.les_details.production.stock_son || 0) : (precedent?.cumul_stock_son || 0)
        actu.stock_theorique_ultra = +actu.les_details.production.stock_ultra

        // actu.cumul_stock_ultra = +(actu.les_details.production.stock_ultra || 0)
        // actu.cumul_stock_normal = +(actu.les_details.production.stock_normal || 0)
        // actu.cumul_stock_vierge = +(actu.les_details.production.stock_vierge || 0)
        // actu.cumul_stock_son = +(actu.les_details.production.stock_son || 0)

        actu.theorique_matin_normal = +actu.controle_veille?.les_details.production.stock_normal + +actu?.les_details.ensache.normal - +actu?.suivant?.les_details.livraison.normal
        actu.difference_normal = actu.les_details.production.stock_normal - +actu.theorique_matin_normal
        if (Math.abs(actu.difference_normal) <= 1) {
          actu.color_normal = "border border-success p-1 rounded-2"

          // actu.color_normal = "badge bg-success text-white"
        } else if (Math.abs(actu.difference_normal) < 3) {
          actu.color_normal = "border border-warning p-1 rounded-2"

          // actu.color_normal = "badge bg-warning text-white"
        } else {
          actu.color_normal = "border border-danger p-1 rounded-2"
          // actu.color_normal = "badge bg-danger text-white"
        }
        actu.difference_ensache_normal = actu?.les_details.ensache.normal - actu?.suivant?.les_details.production.normal + +actu?.les_details.casse.normal + +actu?.les_details.ameliorant.normal
        if (Math.abs(actu.difference_ensache_normal) <= 1) {
          actu.color_ensache_normal = "bg-success text-white"
        } else if (Math.abs(actu.difference_ensache_normal) < 3) {
          actu.color_ensache_normal = "bg-warning text-white"
        } else {
          actu.color_ensache_normal = "bg-danger text-white"
        }
        actu.theorique_matin_ultra = +actu.controle_veille?.les_details.production.stock_ultra + +actu?.les_details.ensache.ultra - +actu?.suivant?.les_details.livraison.ultra// - +actu?.les_details.casse.ultra - +actu?.les_details.ameliorant.ultra
        actu.difference_ultra = actu.les_details.production.stock_ultra - +actu.theorique_matin_ultra
        // actu.difference_ultra = (+precedent?.cumul_stock_ultra || 0) - +actu.les_details.production.stock_ultra
        if (Math.abs(actu.difference_ultra) <= 1) {
          actu.color_ultra = "border border-success p-1 rounded-2"
        } else if (Math.abs(actu.difference_ultra) < 3) {
          actu.color_ultra = "border border-warning p-1 rounded-2"
        } else {
          actu.color_ultra = "border border-danger p-1 rounded-2"
        }
        actu.difference_ensache_ultra = actu?.les_details.ensache.ultra - actu?.suivant?.les_details.production.ultra + +actu?.les_details.casse.ultra + +actu?.les_details.ameliorant.ultra
        if (Math.abs(actu.difference_ensache_ultra) <= 1) {
          actu.color_ensache_ultra = "bg-success text-white"
        } else if (Math.abs(actu.difference_ensache_ultra) < 3) {
          actu.color_ensache_ultra = "bg-warning text-white"
        } else {
          actu.color_ensache_ultra = "bg-danger text-white"
        }
        actu.theorique_matin_vierge = +actu.controle_veille?.les_details.production.stock_vierge + +actu?.les_details.ensache.vierge - +actu?.suivant?.les_details.livraison.vierge// - +actu?.les_details.casse.vierge - +actu?.les_details.ameliorant.vierge
        actu.difference_vierge = actu.les_details.production.stock_vierge - +actu.theorique_matin_vierge
        if (Math.abs(actu.difference_vierge) <= 1) {
          actu.color_vierge = "badge bg-success text-white"
        } else if (Math.abs(actu.difference_vierge) < 3) {
          actu.color_vierge = "badge bg-warning text-white"
        } else {
          actu.color_vierge = "badge bg-danger text-white"
        }
        actu.difference_ensache_vierge = actu?.les_details.ensache.vierge - actu?.suivant?.les_details.production.vierge + +actu?.les_details.casse.vierge + +actu?.les_details.ameliorant.vierge
        if (Math.abs(actu.difference_ensache_vierge) <= 1) {
          actu.color_ensache_vierge = "bg-success text-white"
        } else if (Math.abs(actu.difference_ensache_vierge) < 3) {
          actu.color_ensache_vierge = "bg-warning text-white"
        } else {
          actu.color_ensache_vierge = "bg-danger text-white"
        }
        actu.theorique_matin_son = +actu.controle_veille?.les_details.production.stock_son + +actu?.les_details.ensache.son - +actu?.suivant?.les_details.livraison.son// - +actu?.les_details.casse.son - +actu?.les_details.ameliorant.son
        actu.difference_son = actu.les_details.production.stock_son - +actu.theorique_matin_son
        // actu.difference_son = (+precedent?.cumul_stock_son || 0) - +actu.les_details.production.stock_son
        if (Math.abs(actu.difference_son) <= 1) {
          actu.color_son = "border border-success p-1 rounded-2"
        } else if (Math.abs(actu.difference_son) < 3) {
          actu.color_son = "border border-warning p-1 rounded-2"
        } else {
          actu.color_son = "border border-danger p-1 rounded-2"
        }
        actu.difference_ensache_son = actu?.les_details.ensache.son - actu?.suivant?.les_details.production.son + +actu?.les_details.casse.son + +actu?.les_details.ameliorant.son
        if (Math.abs(actu.difference_ensache_son) <= 1) {
          actu.color_ensache_son = "bg-success text-white"
        } else if (Math.abs(actu.difference_ensache_son) < 3) {
          actu.color_ensache_son = "bg-warning text-white"
        } else {
          actu.color_ensache_son = "bg-danger text-white"
        }
      } else {
        actu.cumul_stock_ultra = +(actu.les_details.production.stock_ultra || 0) + (precedent?.cumul_stock_ultra || 0)// cumul_stock_ultra précédent
        actu.cumul_stock_normal = +(actu.les_details.production.stock_normal || 0) + (precedent?.cumul_stock_normal || 0)// cumul_stock_ultra précédent
        actu.cumul_stock_vierge = +(actu.les_details.production.stock_vierge || 0) + (precedent?.cumul_stock_vierge || 0)// cumul_stock_vierge précédent
        actu.cumul_stock_son = +(actu.les_details.production.stock_son || 0) + (precedent?.cumul_stock_son || 0)// cumul_stock_vierge précédent
        actu.stock_theorique_ultra = +actu.controle_veille?.stock_theorique_ultra + +(actu.mouvement_veille?.les_details.production.stock_ultra || 0)
      }
      res.push(actu)
      return res
    }, [])
      .reverse()
    return res2
  }

  getJoursFerie(): Observable<any> {
    return this.http.get<any>(`https://www.googleapis.com/calendar/v3/calendars/fr.senegal#holiday@group.v.calendar.google.com/events?key=AIzaSyDN8_Ed_LieVfVsznkS3re2cAc3ssM8JBM`)
  }

  is_already_selected(id: any, form: any, condition: string): boolean {
    // Vérifie si la carte est déjà utilisée par un autre employé
    const list = form.some((one_detail: any) => one_detail[condition] === id)[0]?.[condition];
    return !!list;
  }
  update_preference(key: string, value: any) {
    this.preference[key] = value
    this.save_on_local_storage("preference", this.preference)
  }
  go_back() {
    this.location.back()
  }
}
